import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';
import { authService } from '../../services/authService';
import { tokenUtils } from '../../utils/tokenUtils';
import validators from '../../utils/validators';

const NotificationEmailModal = ({
  open,
  onSuccess,
  user,
  setUser,
  refreshUsuarioConCedula,
}) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const trimmed = email.trim();
    if (!validators.required(trimmed)) {
      setError('Ingresa un correo electrónico.');
      return;
    }
    if (!validators.isEmail(trimmed)) {
      setError('Introduce un correo electrónico válido.');
      return;
    }

    setSubmitting(true);
    try {
      await authService.updateMyEmail(trimmed);

      const stored = tokenUtils.getUser();
      if (stored) {
        tokenUtils.setUser({ ...stored, email: trimmed, Email: trimmed });
      }
      if (setUser) {
        setUser((prev) => (prev ? { ...prev, email: trimmed, Email: trimmed } : prev));
      }

      // Cerrar antes del refresh para que el gate no reabra la modal en carrera.
      onSuccess?.();

      if (user?.cedula && refreshUsuarioConCedula) {
        try {
          await refreshUsuarioConCedula(user.cedula);
        } catch (refreshErr) {
          console.warn('Email guardado, pero no se pudo refrescar el perfil local:', refreshErr);
        }
      }
    } catch (err) {
      setError(err.message || 'No se pudo guardar el correo. Inténtalo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
    >
      <Box component="form" onSubmit={handleSubmit}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmailIcon color="primary" />
          Correo para notificaciones
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            No tienes un correo registrado para avisos. Indica el correo donde quieres recibir las
            notificaciones de la plataforma.
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <TextField
            autoFocus
            fullWidth
            label="Correo electrónico"
            type="email"
            name="notification-email"
            autoComplete="email"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
            disabled={submitting}
            margin="normal"
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
            startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : null}
          >
            Guardar
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default NotificationEmailModal;
